module.exports = __webpack_public_path__ + "1129a54273795cedd85b84f61eba0127.svg";